import Vue from 'vue';
import VueRouter from 'vue-router';
import { bindGuards } from './guard';
import exampleConfig from './configs/example';
import teacherConfig from './configs/teacher';
import studentConfig from './configs/student';
import parentConfig from './configs/parent';
import activityConfig from './configs/activity';
import personalityCounselingConfig from './configs/personalityCounseling';
import pencilCase from './configs/pencilCase';
import cooperationConfig from './configs/cooperation';
Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        name: 'Index',
        component: () => import(/* webpackChunkName: "Index" */ '../views/Index.vue'),
    },
    {
        name: 'login',
        path: '/login',
        meta: {
            needNotAuth: true,
        },
        component: () => import('@/views/ucenter/Login'),
    },
    activityConfig,
    exampleConfig,
    teacherConfig,
    studentConfig,
    parentConfig,
    personalityCounselingConfig,
    cooperationConfig,
    pencilCase,
];

const router = new VueRouter({
    mode: 'history',
    base: '/swan/labrador/',
    routes,
});
// 绑定路由守卫
bindGuards(router);
export default router;
